import React from 'react';
import { useTranslation } from 'react-i18next';
import { AbsenceStats } from '../../../../types/absenceTypes';
import SkeletonLoader from '../../../../components/Common/SkeletonLoader';
import '../../../../components/Common/styles/skeleton.css';
import StatCard from '../../../../components/Common/StatCard';
import './styles/statsPanel.css';

interface StatsPanelProps {
  stats: AbsenceStats | null;
  loading: boolean;
}

const StatsPanel: React.FC<StatsPanelProps> = ({ stats, loading }) => {
  const { t } = useTranslation();

  if (loading) {
    return (
      <div className="row">
        {[1, 2, 3, 4].map((i) => (
          <div
            key={i}
            className="col-xl-3 col-sm-6 col-12 d-flex"
            style={{ '--item-index': i } as React.CSSProperties}
          >
            <div className="card bg-comman w-100 skeleton-list-item">
              <div className="card-body">
                <div className="db-widgets d-flex justify-content-between align-items-center">
                  <div className="db-info">
                    <SkeletonLoader type="text" width="80px" height="20px" className="mb-2" index={i} />
                    <SkeletonLoader type="text" width="50px" height="30px" variant="large" index={i} />
                  </div>
                  <div className="db-icon">
                    <SkeletonLoader type="circle" width="40px" height="40px" index={i} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  }

  const cards = [
    { color: 'blue'   as const, icon: 'clock',        title: t('total_absence_hours'),   value: stats?.totalAbsenceHours   ?? 0 },
    { color: 'green'  as const, icon: 'circle-check', title: t('excused_hours'),         value: stats?.totalExcusedHours   ?? 0 },
    { color: 'yellow' as const, icon: 'alert-circle', title: t('pending_hours'),         value: stats?.totalPendingHours   ?? 0 },
    { color: 'red'    as const, icon: 'users',        title: t('students_near_threshold'), value: stats?.studentsNearThreshold ?? 0 },
  ];
  
  return (
    <div className="row">
      {cards.map((c, i) => (
        <div key={i} className="col-xl-3 col-sm-6 col-12 d-flex">
          <StatCard
            color={c.color}
            icon={c.icon}
            title={c.title}
            value={c.value}
          />
        </div>
      ))}
    </div>
  );
};

export default StatsPanel;
